import { React, useEffect, useState, useRef } from "react";
import axios from "axios";
import "./App.css";
import {
  getCampaignsList,
  getActionsList,
  getActionConfig,
  getProductsCatalog,
} from "./services/smasiAPIs.js";
import { Link } from "react-router-dom";
import {
  Layout,
  Row,
  Col,
  Typography,
  FloatButton,
  Tooltip,
  Button,
  Select,
  Tag,
  Divider,
  Switch,
  Input,
  List,
  Card,
  Popover,
} from "antd/lib";

import LoadingSpinner from "./Components/loadingSpinner.js";
import HeaderComponent from "./Components/HeaderComponent.js";
import {
  listRealTimeResults,
  createResultsFolder,
} from "./services/azureBlobService";

import { FileTextOutlined, HomeOutlined } from "@ant-design/icons";
import { ReactComponent as ClientLogo } from "./Assets/cm_logo.svg";
import { ReactComponent as CrdClientLogo } from "./Assets/crd_logo.svg";
import { message } from "antd";

const client =
  window.location.host.startsWith("vw.") ||
  window.location.href.includes("client=vw")
    ? "vw"
    : "cm";
const { Content } = Layout;
const { Option } = Select;
const { Title, Text } = Typography;

const CampaignMonitoring = () => {
  const [popoverVisible, setPopoverVisible] = useState(false);

  const togglePopover = () => {
    setPopoverVisible((prev) => !prev);
  };

  const [loading, setLoading] = useState(false);
  const [marketConfig, setMarketConfig] = useState(null);
  const [languageConfig, setLanguageConfig] = useState(null);
  const [brandId, setBrandId] = useState(null);
  const [smasiInstance, setSmasiInstance] = useState(null);
  const [collectionsList, setCollectionsList] = useState([]);
  const [selectedCollection, setSelectedCollection] = useState(null);
  const [selectedCollectionId, setSelectedCollectionId] = useState(null);
  const [campaignsList, setCampaignsList] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [selectedCampaignId, setSelectedCampaignId] = useState(null);
  const [actionsList, setActionsList] = useState([]);
  const [selectedAction, setSelectedAction] = useState(null);
  const [selectedActionId, setSelectedActionId] = useState(null);
  const [productsCatalog, setProductsCatalog] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [isPreliveGTMTest, setIsPreLiveGTMTest] = useState(false); // Default to "No"
  const [isPreliveParamTest, setIsPreLiveParamTest] = useState(false);
  const [gtmTestlink, setGtmTestlink] = useState("");
  const [urlParamPrelive, setUrlParamPrelive] = useState("sdStagingData");
  const [testButtonIsEnabled, setTestButtonIsEnabled] = useState(false);
  const [testRunComplete, setTestRunComplete] = useState(false);
  const [testLogs, setTestLogs] = useState([]);
  const [lastFiveResults, setLastFiveResults] = useState([]);
  const [currentTestRunId, setCurrentTestRunId] = useState(null);
  const logContainerRef = useRef(null);
    useEffect(() => {
    document.title = `QA Auditor | Campaign Monitoring`;

    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://sdqareports.z6.web.core.windows.net/config/${client}/marketConfig.json`
        );
        const languageJson = await axios.get(
          `https://sdqareports.z6.web.core.windows.net/config/languageConfig.json`
        );
        setMarketConfig(response.data);
        setLanguageConfig(languageJson.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (marketConfig !== null) {
      setCollectionsList(
        client === "cm"
          ? marketConfig["Nissan Motor Company"]
          : marketConfig["Volkswagen"]
      );
    }
  }, [marketConfig]);

  useEffect(() => {
    if (selectedCollection !== null) {
      const fetchRealTimeResultFolders = async () => {
        const folders = await listRealTimeResults(
          "$web",
          `${selectedCollection.toLowerCase()}/real-time/`
        );
        setLastFiveResults(folders.slice(0, 5));

        const lastTestName = folders.length > 0 ? folders[0].name : "test-0";
        const currentTestId = `test-${
          parseInt(lastTestName.split("-")[1]) + 1
        }`;
        setCurrentTestRunId(currentTestId);
      };
      fetchRealTimeResultFolders();
    }
  }, [selectedCollection]);

  useEffect(() => {
    if (testRunComplete === true) {
      const fetchRealTimeResultFolders = async () => {
        const folders = await listRealTimeResults(
          "$web",
          `${selectedCollection.toLowerCase()}/real-time/`
        );
        setLastFiveResults(folders.slice(0, 5));

        const lastTestName = folders.length > 0 ? folders[0].name : "test-0";
        const currentTestId = `test-${
          parseInt(lastTestName.split("-")[1]) + 1
        }`;
        setCurrentTestRunId(currentTestId);
      };
      fetchRealTimeResultFolders();
      window.open(
        `/${selectedCollection.toLowerCase()}/real-time/${currentTestRunId}/results`
      );
    }
  }, [testRunComplete]);

  useEffect(() => {
    if (selectedCollectionId !== null) {
      setCampaignsList([]);

      getProductsCatalog(smasiInstance, brandId).then((productsCatalog) => {
        setProductsCatalog(productsCatalog);
      });

      getCampaignsList(smasiInstance, selectedCollectionId).then(
        (apiCampaignsList) => {
          apiCampaignsList.sort((a, b) => a.name.localeCompare(b.name));
          setCampaignsList(apiCampaignsList);
        }
      );
    }
  }, [selectedCollectionId]);

  useEffect(() => {
    if (selectedCampaignId !== null) {
      setActionsList([]);

      getActionsList(
        smasiInstance,
        selectedCollectionId,
        selectedCampaignId
      ).then((actionsList) => {
        var _actionsList = actionsList.actions;
        _actionsList.sort((a, b) => a.name.localeCompare(b.name));
        setActionsList(_actionsList);
      });
    }
  }, [selectedCampaignId]);

  useEffect(() => {
    if (selectedActionId !== null) {
      setProductsList([]);

      var actionConfigurations = [];
      getActionConfig(smasiInstance, selectedActionId).then((actionConfig) => {
        actionConfig.config !== undefined &&
        actionConfig.config.urlConfigurations !== undefined
          ? (actionConfigurations = actionConfig.config.urlConfigurations)
          : (actionConfigurations = actionConfig.config.scripts);

        var _productsList = [];
        for (const actionConfiguration of actionConfigurations) {
          var tempProduct = {};
          tempProduct.id =
            actionConfiguration.itemId === null
              ? ""
              : actionConfiguration.itemId;
          tempProduct.name =
            actionConfiguration.itemId === null
              ? "No_Product"
              : productsCatalog.find(
                  (product) => product.id === actionConfiguration.itemId
                ).name;
          tempProduct.language =
            actionConfiguration.languageId !== null
              ? smasiInstance === "ceres"
                ? languageConfig["ceres"].find(
                    (language) =>
                      language.languageId === actionConfiguration.languageId
                  ).name
                : languageConfig["mars"].find(
                    (language) =>
                      language.languageId === actionConfiguration.languageId
                  ).name
              : null;
          _productsList.push(tempProduct);
        }
        _productsList.sort((a, b) => a.name.localeCompare(b.name));
        setProductsList(_productsList);
      });
    }
  }, [selectedActionId]);

  useEffect(() => {
    if (logContainerRef.current) {
      logContainerRef.current.scrollTop = logContainerRef.current.scrollHeight;
    }
  }, [testLogs]);

  const handleSelectedCollection = async (value, option) => {
    setCampaignsList([]);
    setSelectedCampaign(null);
    setSelectedCampaignId(null);
    setActionsList([]);
    setSelectedAction(null);
    setSelectedProducts([]);
    setProductsCatalog([]);

    setSelectedCollection(value);
    const collectionId = collectionsList.find(
      (collection) => collection.name === value
    ).id;
    setSmasiInstance(
      client === "cm" || value.toUpperCase() === "VWUSA" ? "ceres" : "mars"
    );
    setBrandId(
      collectionsList.find(
        (collectionConfig) => collectionConfig.id === collectionId
      ).brandId
    );
    setSelectedCollectionId(collectionId);
  };

  const handleSelectedCampaign = async (value, option) => {
    setActionsList([]);
    setSelectedAction(null);
    setSelectedProducts([]);

    setSelectedCampaign(value);
    const campaignId = campaignsList.find(
      (campaign) => campaign.name === value
    ).id;
    setSelectedCampaignId(campaignId);
  };

  const handleSelectedAction = async (value, option) => {
    setSelectedProducts([]);
    setSelectedAction(value);

    const actionId = actionsList.find((action) => action.name === value).id;
    setSelectedActionId(actionId);
    setTestButtonIsEnabled(true);
  };

  const handleSelectedProducts = async (value, option) => {
    setSelectedProducts(value);
  };

  const addToTestLog = (message) => {
    setTestLogs((prevLog) =>
      prevLog.includes(message) ? prevLog : [...prevLog, message]
    );
  };

  const pollGetAPI = async () => {
    return new Promise((resolve) => {
      let count = 0; // Track number of "ok" responses

      const interval = setInterval(async () => {
        try {
          const response = await fetch(
            "https://qa-auditor.mars.cmg-platform.com/status",
            {
              method: "GET",
              headers: {
                Authorization: process.env.REACT_APP_QA_AUDITOR_API_KEY,
                "Content-Type": "application/json",
              },
            }
          );
          const data = await response.json();

          if (data.status === "OK") {
            count++;
            setTestLogs((prevLogs) => [`Waiting for server to start... `]);
          } else {
            count = 0; // Reset count if not "ok"
            setTestLogs((prevLogs) => [...prevLogs, "GET API: Status NOT OK"]);
          }

          // Stop polling after 5 consecutive "ok"
          if (count >= 6) {
            clearInterval(interval);
            setTestLogs((prevLogs) => [
              ...prevLogs,
              `Server is ready! Starting tests now...`,
            ]);
            resolve(true);
          }
        } catch (error) {
          setTestLogs((prevLogs) => [
            ...prevLogs,
            `GET API Error: ${error.message}`,
          ]);
        }
      }, 10000); // Poll every 10 seconds
    });
  };

  const handleStartQA = async () => {
    // setLoading(true);
    setTestButtonIsEnabled(false);
    addToTestLog("Connecting with test server...");

    const createResultFolder = async () => {
      const runResultFolderName = `${selectedCollection.toLowerCase()}/real-time/${currentTestRunId}`;
      const result = await createResultsFolder("$web", runResultFolderName);
      if (result.success) {
        console.log("Results folder created");
      } else {
        console.log("Results folder NOT created");
      }
    };
    createResultFolder();

    const isReady = await pollGetAPI();
    if (!isReady) {
      addToTestLog("GET API condition not met. Aborting...");
      setLoading(false);
      return;
    }

    // message.success("Server is up & running...");

    try {
      const reqBody = {
        smasiUrl: null,
        issueId: `real-time/${currentTestRunId}/results`,
        client: client,
        collection: selectedCollection.toLowerCase(),
        additionalUrlTestParameter:
          isPreliveParamTest && !isPreliveGTMTest ? urlParamPrelive : null,
        gtmTestLink:
          isPreliveGTMTest && !isPreliveParamTest ? gtmTestlink : null,
        actionSpecs: [
          {
            id: selectedActionId,
            items: selectedProducts,
          },
        ],
      };

      const reqUrl = "https://qa-auditor.mars.cmg-platform.com/run-tests";
      // console.log("Calling >> ", reqUrl);
      const response = await fetch(reqUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: process.env.REACT_APP_QA_AUDITOR_API_KEY,
        },
        body: JSON.stringify(reqBody),
      });

      if (!response.body) throw new Error("No response body");

      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;

        let chunk = decoder.decode(value);
        chunk = chunk
          .split("\n") // Split into lines
          .filter((line) => line.trim() !== "") // Remove empty lines
          .join("\n");
        setTestLogs((prevLogs) => [
          ...prevLogs,
          chunk
            .replaceAll("data: ", "")
            .replaceAll("Task still running...", ""),
        ]);
      }
      setTestButtonIsEnabled(true);
      setTestRunComplete(true);
    } catch (error) {
      setTestLogs((prevLogs) => [...prevLogs, `Error: ${error.message}`]);
    }
    setTestLogs((prevLogs) => [...prevLogs, ""]);
    setLoading(false);
  };

  if (loading) return <LoadingSpinner></LoadingSpinner>;

  return (
    <div>
      <Layout className="layout">
        <HeaderComponent collectionsList={collectionsList} />
        <Content
          style={{
            height: "100vh",
            background: "#F7FAF2",
          }}
        >
          <div style={{ padding: "0 4vh" }}>
            <Row
              justify="space-between"
              align="middle"
              style={{ marginTop: "1.8rem" }}
            >
              <Col>
                <Text
                  strong
                  style={{
                    fontFamily: `${client}Compact`,
                    fontSize: client === "vw" ? "3.167rem" : "4.167rem",
                    lineHeight: "0.75",
                  }}
                >
                  CAMPAIGN MONITORING
                </Text>
              </Col>
              <Col>
                {client === "cm" && (
                  <ClientLogo
                    style={{
                      marginTop: "12px",
                      height: "2rem",
                    }}
                  />
                )}
                {client === "vw" && (
                  <CrdClientLogo
                    style={{
                      marginTop: "12px",
                      height: "2.6rem",
                    }}
                  />
                )}
              </Col>
            </Row>
            <Row gutter={24} style={{ marginTop: "2rem" }}>
              <Col className="gutter-row" span={3}>
                <Popover
                  overlayInnerStyle={{
                    fontFamily: `${client}Regular`,
                  }}
                  content={
                    <p>
                      Choose the Collection, Campaign, Action and Products that
                      you would like to test.
                    </p>
                  }
                  // title="Popover Title"
                  trigger="click"
                  placement="top"
                  overlayStyle={{
                    maxWidth: 700,
                  }}
                  overlayClassName="tutorialPopover"
                  open={popoverVisible}
                  onOpenChange={(visible) => setPopoverVisible(visible)}
                />
                <Title
                  level={5}
                  style={{ fontFamily: `${client}Bold`, fontSize: "0.944rem" }}
                >
                  Collection
                </Title>
                <Select
                  key="client"
                  // defaultValue={}
                  showSearch
                  placeholder="Select collection"
                  style={{ flex: 1, width: "11vw" }}
                  onChange={handleSelectedCollection}
                  value={selectedCollection || undefined}
                  dropdownStyle={{
                    fontFamily: `${client}Regular`,
                    fontSize: "0.944rem",
                  }}
                >
                  {collectionsList.map((collection) => (
                    <Option key={collection.name} value={collection.name}>
                      {collection.name}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col className="gutter-row" span={5}>
                <Title
                  level={5}
                  style={{ fontFamily: `${client}Bold`, fontSize: "0.944rem" }}
                >
                  Campaign
                </Title>
                <Select
                  key="campaign"
                  showSearch
                  disabled={!selectedCollection || loading}
                  placeholder="Select campaign"
                  style={{ flex: 1, width: "19vw" }}
                  onChange={handleSelectedCampaign}
                  value={selectedCampaign || undefined}
                  dropdownStyle={{
                    fontFamily: `${client}Regular`,
                    fontSize: "0.944rem",
                  }}
                >
                  {campaignsList.map((campaign) => (
                    <Option key={campaign.name} value={campaign.name}>
                      {campaign.name}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col className="gutter-row" span={5}>
                <Title
                  level={5}
                  style={{ fontFamily: `${client}Bold`, fontSize: "0.944rem" }}
                >
                  Action
                </Title>
                <Select
                  key="action"
                  showSearch
                  disabled={!selectedCampaign || loading}
                  placeholder="Select action"
                  style={{ flex: 1, width: "19vw" }}
                  onChange={handleSelectedAction}
                  value={selectedAction || undefined}
                  dropdownStyle={{
                    fontFamily: `${client}Regular`,
                    fontSize: "0.944rem",
                  }}
                >
                  {actionsList.map((action) => (
                    <Option key={action.name} value={action.name}>
                      {action.name}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col className="gutter-row" span={5}>
                <Title
                  level={5}
                  style={{ fontFamily: `${client}Bold`, fontSize: "0.944rem" }}
                >
                  Product
                </Title>
                <Select
                  key="product"
                  mode="multiple"
                  showSearch
                  disabled={!selectedAction || loading}
                  placeholder="All"
                  style={{ flex: 1, width: "19vw" }}
                  onChange={handleSelectedProducts}
                  value={selectedProducts || []}
                  dropdownStyle={{
                    fontFamily: `${client}Regular`,
                    fontSize: "0.944rem",
                  }}
                >
                  {productsList.map((product) => (
                    <Option
                      key={
                        product.language !== null
                          ? product.language + "_" + product.name
                          : product.name
                      }
                      value={
                        product.language !== null
                          ? product.language + " | " + product.name
                          : product.name
                      }
                    >
                      {product.language !== null && (
                        <Tag color="blue">{product.language}</Tag>
                      )}
                      {product.language !== null && <Divider type="vertical" />}
                      {product.name}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
            <Row align="middle" gutter={16} style={{ marginTop: "2rem" }}>
              <Col style={{ width: "30rem" }}>
                <Text
                  disabled={isPreliveGTMTest}
                  style={{ fontFamily: `${client}Bold`, fontSize: "0.944rem" }}
                >
                  Do you want to test pre-live by adding an URL parameter?
                </Text>
              </Col>
              <Col>
                <Switch
                  disabled={isPreliveGTMTest}
                  checked={isPreliveParamTest}
                  onChange={(value) => setIsPreLiveParamTest(value)}
                  checkedChildren="Yes"
                  unCheckedChildren="No"
                  style={{
                    fontFamily: `${client}Bold`,
                    fontSize: "0.944rem",
                    background: isPreliveParamTest ? "#2045C0" : "gray",
                  }}
                />
                <Popover
                  overlayInnerStyle={{
                    fontFamily: `${client}Regular`,
                  }}
                  content={
                    <p>
                      Toggle on if you would like to test by adding URL
                      parameter to the test. You can change the URL parameter as
                      needed or use the set value.
                    </p>
                  }
                  // title="Popover Title"
                  trigger="click"
                  placement="right"
                  overlayStyle={{
                    maxWidth: 800,
                  }}
                  overlayClassName="tutorialPopover"
                  open={popoverVisible}
                  onOpenChange={(visible) => setPopoverVisible(visible)}
                />
              </Col>
            </Row>
            {isPreliveParamTest && (
              <Row align="middle" gutter={16} style={{ marginTop: "1rem" }}>
                <Col>
                  <Text
                    style={{
                      fontFamily: `${client}Bold`,
                      fontSize: "0.944rem",
                    }}
                  >
                    Enter URL Parameter:
                  </Text>
                </Col>
                <Col>
                  <Input
                    placeholder="Enter here..."
                    value={urlParamPrelive}
                    onChange={(e) => setUrlParamPrelive(e.target.value)}
                    style={{ width: 500 }}
                  />
                </Col>
              </Row>
            )}
            <Row align="middle" gutter={16} style={{ marginTop: "2rem" }}>
              <Col style={{ width: "30rem" }}>
                <Text
                  disabled={isPreliveParamTest}
                  style={{ fontFamily: `${client}Bold`, fontSize: "0.944rem" }}
                >
                  Do you want to test pre-live with GTM Testlink? {"       "}
                </Text>
              </Col>
              <Col>
                <Switch
                  disabled={isPreliveParamTest}
                  checked={isPreliveGTMTest}
                  onChange={(value) => setIsPreLiveGTMTest(value)}
                  checkedChildren="Yes"
                  unCheckedChildren="No"
                  style={{
                    fontFamily: `${client}Bold`,
                    fontSize: "0.944rem",
                    background: isPreliveGTMTest ? "#2045C0" : "gray",
                  }}
                />
                <Popover
                  overlayInnerStyle={{
                    fontFamily: `${client}Regular`,
                  }}
                  content={<p>Input the complete GTM Preview Link</p>}
                  // title="Popover Title"
                  trigger="click"
                  placement="bottomRight"
                  overlayStyle={{
                    maxWidth: 500,
                  }}
                  overlayClassName="tutorialPopover"
                  open={popoverVisible}
                  onOpenChange={(visible) => setPopoverVisible(visible)}
                />
              </Col>
            </Row>
            {isPreliveGTMTest && (
              <Row align="middle" gutter={16} style={{ marginTop: "1rem" }}>
                <Col>
                  <Text
                    style={{
                      fontFamily: `${client}Bold`,
                      fontSize: "0.944rem",
                    }}
                  >
                    Enter GTM Testlink:
                  </Text>
                </Col>
                <Col>
                  <Input
                    placeholder="Enter here..."
                    value={gtmTestlink}
                    onChange={(e) => setGtmTestlink(e.target.value)}
                    style={{ width: 790 }}
                  />
                </Col>
              </Row>
            )}
            <Row
              justify="center"
              style={{ marginTop: "2rem", alignItems: "center" }}
            >
              <Popover
                overlayInnerStyle={{
                  fontFamily: `${client}Regular`,
                }}
                content={<p>Click to begin tests.</p>}
                // title="Popover Title"
                trigger="click"
                placement="top"
                overlayStyle={{
                  maxWidth: 300,
                }}
                overlayClassName="tutorialPopover"
                open={popoverVisible}
                onOpenChange={(visible) => setPopoverVisible(visible)}
              />
              <Button
                type="primary"
                disabled={!testButtonIsEnabled}
                onClick={handleStartQA}
                style={{
                  fontFamily: `${client}Regular`,
                  marginTop: "2rem",
                  width: "10rem",
                  height: "2.5rem",
                  background: testButtonIsEnabled ? "#2045C0" : "",
                  color: testButtonIsEnabled ? "#FFFFFF" : "",
                }}
              >
                Start QA
              </Button>
            </Row>
            {testLogs.length > 0 && (
              <Row
                justify="start"
                style={{ marginTop: "4rem", marginBottom: "2rem" }}
              >
                <Popover
                  overlayInnerStyle={{
                    fontFamily: `${client}Regular`,
                  }}
                  content={
                    <p>
                      The progress field inform you on the status of the test
                      that you are running.
                    </p>
                  }
                  // title="Popover Title"
                  trigger="click"
                  placement="top"
                  overlayStyle={{
                    maxWidth: 700,
                  }}
                  overlayClassName="tutorialPopover"
                  open={popoverVisible}
                  onOpenChange={(visible) => setPopoverVisible(visible)}
                />
                <Card
                  style={{
                    width: "100%",
                    height: "500px",
                    overflowY: "auto",
                    backgroundColor: "#282c34",
                    color: "#00ff00",
                    fontFamily: "monospace",
                    padding: "10px",
                    whiteSpace: "pre-wrap",
                    marginBottom: "2rem",
                  }}
                  ref={logContainerRef}
                >
                  {testLogs.map((log, index) => (
                    <div key={index}>{log}</div>
                  ))}
                </Card>
              </Row>
            )}
            {selectedCollection && (
              <Row
                justify="start"
                style={{ marginTop: "4rem", marginBottom: "2rem" }}
              >
                <Divider
                  orientation="left"
                  style={{ fontFamily: `${client}Bold`, fontSize: `1.111rem` }}
                >
                  Recent Test Results Archive
                </Divider>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "flex-start",
                    marginTop: "1.2rem",
                  }}
                >
                  <Popover
                    overlayInnerStyle={{
                      fontFamily: `${client}Regular`,
                    }}
                    content={
                      <p>
                        You will see and be able to access the last 5 tests that
                        have been run from here.
                      </p>
                    }
                    // title="Popover Title"
                    trigger="click"
                    placement="top"
                    overlayStyle={{
                      maxWidth: 800,
                    }}
                    overlayClassName="tutorialPopover"
                    open={popoverVisible}
                    onOpenChange={(visible) => setPopoverVisible(visible)}
                  />
                  <List
                    style={{ width: "100%" }}
                    grid={{
                      gutter: 16,
                      xs: 1,
                      sm: 2,
                      md: 3,
                      lg: 3,
                      xl: 4,
                    }}
                    // itemLayout="horizontal"
                    dataSource={lastFiveResults}
                    renderItem={(result) => (
                      <List.Item style={{ width: "100%" }}>
                        <Link
                          key={result.name}
                          target="_blank"
                          to={`/${selectedCollection.toLowerCase()}/real-time/${
                            result.name
                          }/results`}
                        >
                          <Card
                            className="archiveResultsCard"
                            title={result.name}
                            styles={{
                              header: { background: "#F7FAF2", padding: "0" },
                              body: {
                                fontFamily: `${client}Slanted`,
                                background:
                                  client === "vw" ? "#D4E2F1BF" : "#D6E6F8",
                                padding: "1rem !important",
                              },
                            }}
                            style={{
                              fontFamily: `${client}Bold`,
                              fontSize: "0.833rem",
                              width: "100%",
                              minWidth: 240,
                              boxSizing: "border-box",
                              border: "transparent",
                              borderRadius: "0",
                            }}
                          >
                            <p>
                              Last Run:{" "}
                              {new Date(result.createdOn).toLocaleString()}
                            </p>
                          </Card>
                        </Link>
                      </List.Item>
                    )}
                  />
                </div>
              </Row>
            )}
          </div>
          <FloatButton
            icon={<FileTextOutlined />}
            description="HELP"
            shape="square"
            className="helpButton"
            onClick={togglePopover}
            style={{
              fontFamily: `${client}Regular`,
              insetInlineEnd: 0,
              top: "80%",
              transform: "translateY(-50%)",
              maxHeight: "48px",
            }}
          />
        </Content>
      </Layout>
    </div>
  );
};
export default CampaignMonitoring;
